"use client";
import {
  useCompositeStoreProps
} from "./4CMBR7SL.js";
import {
  useStore
} from "./YV4JVR4I.js";

// src/menubar/menubar-store.ts
import * as Core from "@ariakit/core/menubar/menubar-store";
function useMenubarStoreProps(store, update, props) {
  return useCompositeStoreProps(store, update, props);
}
function useMenubarStore(props = {}) {
  const [store, update] = useStore(Core.createMenubarStore, props);
  return useMenubarStoreProps(store, update, props);
}

export {
  useMenubarStoreProps,
  useMenubarStore
};
